import React, { Children, useEffect, useState } from "react";

const MirumTabsGroup = ({ children, selectedIndex }) => {
  console.log("TabsGroup children", children);

  const [selectedTabIndex, setSelectedTabIndex] = useState(null);

  let tabs = [];
  let tabsContent = [];

  if (selectedTabIndex === null && Children.count(children) > 0) {
    setSelectedTabIndex(0);
  }

  useEffect(() => {
    if (selectedIndex != null) {
      setSelectedTabIndex(selectedIndex);
    }
  }, [selectedIndex]);

  Children.map(children, (child, index) => {
    console.log("TabsGroup child", child, index);

    let title = child.props?.title;
    let content = child.props?.children;

    let isSelected = selectedTabIndex === index;

    tabs.push(
      <div
        className={`p-4 cursor-pointer lowercase border-b-2 border-transparent ${
          isSelected
            ? " border-[var(--peachy-pink)] text-[var(--peachy-pink)] font-black"
            : "text-black"
        }
          hover:border-[var(--peachy-pink)] transition-all
          
          `}
        onClick={() => {
          setSelectedTabIndex(index);
        }}
      >
        {title}
      </div>
    );
    tabsContent.push(content);

    return child;
  });

  return (
    <div className="w-full text-center">
      {/* <div className="w-full sticky top-0 left-0 z-20 bg-white"> */}
      <div className="mx-auto items-center text-center inline-block w-auto">
        <div className="flex items-center">{tabs}</div>
      </div>
      {/* </div> */}
      <div className="text-left">
        {selectedTabIndex !== null && tabsContent[selectedTabIndex]}
      </div>
    </div>
  );
};

export default MirumTabsGroup;
